import { render, staticRenderFns } from "./status-tag.vue?vue&type=template&id=45a6000a&scoped=true"
import script from "./status-tag.vue?vue&type=script&lang=js"
export * from "./status-tag.vue?vue&type=script&lang=js"
import style0 from "./status-tag.vue?vue&type=style&index=0&id=45a6000a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a6000a",
  null
  
)

export default component.exports